// @flow
import { styled } from 'linaria/react';
export const SettingsGroup =
/*#__PURE__*/
styled("div")({
  name: "SettingsGroup",
  class: "sor17yn"
});
export const Label =
/*#__PURE__*/
styled("label")({
  name: "Label",
  class: "lgro6t3"
});
export const Section =
/*#__PURE__*/
styled("section")({
  name: "Section",
  class: "s15xrqma"
});
export const Button =
/*#__PURE__*/
styled("button")({
  name: "Button",
  class: "b19hlbq0"
});